<template>
    <div>
        <v-dialog :width="($vuetify.breakpoint.mdAndUp)? '60%' : '95%'" persistent :value="showDialog">
            <v-card>
                <v-card-title>Verify your email account</v-card-title>
                <v-card-text>
                    <p>{{$t('To continue, verify your email account')}}: {{user.email}}</p>
                </v-card-text>
                <v-card-actions  class="d-flex justify-end">
                    <secondary-button @clickBtn="showDialog = false" :disabled="resended" :loading="loading" :activeButton="true">Close</secondary-button>
                    <primary-button @clickBtn="resend()" :loading="loading"  class="ml-4" :activeButton="true">Resend email</primary-button>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import {resendConfirmation, dialogEmailDisplayed} from "@/api/user";

    export default {
        data:() => {
            return{
                resended:false,
                loading:false,
                showDialog:false,
            }
        },
        computed:{
            user(){return this.$store.getters.user}
        },
        watch:{
            user: function () {
              this.check();
            }
        },
        mounted(){
            this.check();
        },
        methods:{
            check(){
                if(this.user && this.user.email_verified_at == null && this.user.show_email_dialog){
                    this.showDialog = true;
                    this.dialogDisplayed();
                }else{
                    this.showDialog = false;
                }
            },
            resend(){
                this.loading = true;
                resendConfirmation({email: this.user.email}).then(res => {
                    this.loading = false;
                    this.showDialog = false;
                    this.$store.commit('app/ADD_MESSAGE', {text: 'Email successfully sent.', type: 'success'});
                })
            },
            dialogDisplayed(){
                dialogEmailDisplayed().then(res=>{});
            }
        }
    }
</script>
